let mutations = {
    setHRecordModel(state, data) {
        // 变更low-level-model
        let index = data.index;
        let recordModel = data.recordModel;
        state.recordModel[index - 1] = recordModel;
        // state.recordModel.push(recordModel);
    },
    clearHRecord(state) {
        state.recordModel = [];
    },
    setAllHRecordModel(state, data) {
        // 变更low-level-model
        state.recordModel = data;
    }
}
export default mutations;


// WEBPACK FOOTER //
// ./src/vuex/modules/hRecordModel/mutations.js